var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 21C6.95 21 6.47933 20.8043 6.088 20.413C5.69667 20.0217 5.50067 19.5507 5.5 19V6H4.5V4H9.5V3H15.5V4H20.5V6H19.5V19C19.5 19.55 19.3043 20.021 18.913 20.413C18.5217 20.805 18.0507 21.0007 17.5 21H7.5ZM17.5 6H7.5V19H17.5V6ZM9.5 17H11.5V8H9.5V17ZM13.5 17H15.5V8H13.5V17Z",
    fill: "#8B8989"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteOutline);
export default __webpack_public_path__ + "static/media/delete-outline.f7998c35edc3650d0933f285eef62f7c.svg";
export { ForwardRef as ReactComponent };